// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"742":"bf15703a","809":"915c0537"}[chunkId] + ".chunk.css";
};